import {ChakraProvider, ColorModeScript} from "@chakra-ui/react";
import {StrictMode}                      from "react";
import ReactDOM                          from "react-dom/client";
import "./index.css";
import {BrowserRouter}                   from "react-router-dom";
import App                               from "./App";
import reportWebVitals                   from "./reportWebVitals";
import theme                             from "./theme/theme";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <StrictMode>
        <BrowserRouter>
            <ChakraProvider theme={theme}>
                {/*ColorModeScript needed to set the theme according to OS*/}
                <ColorModeScript initialColorMode={theme.config.initialColorMode}/>
                <App/>
            </ChakraProvider>
        </BrowserRouter>
    </StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
